export const DEFAULT_DATE_REGEX = '^(0[1-9]|[12][0-9]|3[01])\\.(0[1-9]|1[012])\\.(1[9]|2[0])\\d{2}$';
export const USA_DATE_REGEX = '^(0[1-9]|1[012])\\/(0[1-9]|[12][0-9]|3[01])\\/(1[9]|2[0])\\d{2}$';

export const PHONE_CUSTOM_MASK = {
    ug: '(...) ...-...',
    kz: '(...) ...-..-......',
    gb: '.... ...-...',
    uz: '..-...-....',
    lv: '..-...-...',
    ua: '... ... ...',
    cz: '(...) ...-...',
    au: '.-....-....',
    it: '...-....-...',
    ng: '(...) ...-....',
    bd: '..-...-...-..',
    at: '(...) ...-....-...',
    cn: '..-.....-.....',
    gr: '..-...-.......',
    al: '.. ...-....',
    ad: '...-...-...',
    be: '(....) ...-...',
    ba: '..-...-....',
    bg: '(...) ...-...',
    by: '(..) ...-..-..',
    hr: '... ... ...',
    cy: '.... ....',
    dk: '..-..-..-..',
    ee: '....-....',
    fi: '(..) ...-..-...',
    fr: '(...) ...-...',
    de: '(...) ...-...-..',
    hu: '(...) ...-...',
    is: '...-....',
    ie: '(...) ...-...',
    kg: '(...) ...-...',
    li: '... ... ...',
    lt: '. ... ....',
    lu: '(...) ...-...',
    mt: '....-....',
    mc: '... ... ...',
    md: '....-....',
    me: '..-...-...',
    nl: '..-...-....',
    no: '... .. ...',
    pl: '.. ... .. ..',
    pt: '..-...-....',
    ro: '..-...-....',
    sm: '.. .. .... ..',
    rs: '..-...-....',
    sk: '... ... ...',
    si: '..-...-...',
    es: '(...) ...-...',
    se: '..-...-....',
    ch: '..-...-....',
    mk: '..-...-...',
    us: '(...) ...-....',
    ae: '..-...-....',
    af: '..-...-....',
    am: '..-...-...',
    ao: '(...) ...-...',
    ar: '. .. .... ....',
    aw: '...-....',
    az: '..-...-..-..',
    bf: '..-..-....',
    bh: '....-....',
    bi: '..-..-....',
    bj: '..-..-....',
    bn: '...-....',
    bo: '.-...-....',
    br: '..-....-.....',
    bt: '..-...-...',
    bw: '..-...-...',
    bz: '...-....',
    cd: '(...) ...-...',
    cf: '..-..-....',
    cg: '..-...-....',
    ci: '..-...-...',
    cl: '.-....-....',
    cm: '....-.....',
    co: '(...) ...-....',
    cr: '....-....',
    cu: '.-...-....',
    cv: '(...) ..-..',
    cw: '....-....',
    dj: '..-..-..-..',
    dz: '..-...-....',
    ec: '..-...-....',
    eg: '(...) ...-....',
    er: '.-...-...',
    et: '..-...-....',
    fj: '..-.....',
    fm: '...-....',
    gp: '(...) ...-...',
    ga: '.-..-..-...',
    ge: '(...) ...-...',
    gf: '.....-....',
    gh: '(...) ...-...',
    gm: '(...) ..-..',
    gn: '..-...-....',
    gq: '..-...-....',
    gt: '.-...-....',
    gw: '.-........',
    gy: '...-....',
    hk: '....-....',
    hn: '....-....',
    ht: '..-..-....',
    id: '(...) ...-..-...',
    il: '..-...-....',
    in: '(....) ...-...',
    io: '...-....',
    iq: '(...) ...-....',
    ir: '(...) ...-....',
    jo: '.-....-....',
    jp: '..-....-....',
    ke: '...-......',
    kh: '..-...-...',
    ki: '..-...',
    km: '..-.....',
    kp: '...-....-...',
    kr: '..-....-....',
    kw: '....-....',
    la: '(....) ...-...',
    lb: '..-...-...',
    lk: '..-...-....',
    lr: '..-...-.....',
    ls: '.-...-....',
    ly: '..-...-....',
    ma: '..-....-...',
    mg: '..-..-.....',
    mh: '...-....',
    ml: '..-..-....',
    mm: '..-...-...',
    mn: '..-..-....',
    mo: '....-....',
    mq: '(...) ..-..-..',
    mr: '..-..-....',
    mu: '...-....',
    mv: '...-....',
    mw: '.-....-....',
    mx: '(...) ..-..-....',
    my: '..-...-.....',
    mz: '..-...-....',
    na: '..-...-....',
    nc: '..-....',
    ne: '..-..-....',
    ni: '....-....',
    np: '..-...-.....',
    nr: '...-....',
    nz: '(...) ...-....',
    om: '..-...-...',
    pa: '...-....',
    pe: '(...) ...-...',
    pf: '..-..-..',
    pg: '(...) ..-...',
    ph: '(...) ...-....',
    pk: '(...) ...-....',
    ps: '..-...-....',
    pw: '...-....',
    py: '(...) ...-...',
    qa: '....-....',
    re: '.....-....',
    rw: '(...) ...-...',
    sa: '.-....-....',
    sb: '...-....',
    sc: '.-...-...',
    sd: '..-...-....',
    sg: '....-....',
    sl: '..-......',
    sn: '..-...-....',
    so: '..-...-...',
    sr: '...-....',
    ss: '..-...-....',
    st: '..-.....',
    sv: '..-..-....',
    sy: '..-....-...',
    sz: '..-..-....',
    td: '..-..-..-..',
    tg: '..-...-...',
    th: '..-...-....',
    tj: '..-...-....',
    tl: '...-.....',
    tm: '.-...-....',
    tn: '..-...-...',
    to: '.....',
    tr: '(...) ...-....',
    tv: '......',
    tw: '.-....-....',
    tz: '..-...-....',
    uy: '.-...-..-...',
    ve: '(...) ...-....',
    vn: '(...) ....-...',
    vu: '..-.....',
    ws: '..-....',
    ye: '...-...-...',
    za: '..-...-....',
    zm: '..-...-....',
    zw: '...-......',
} as const;

export type PhoneMaskCountryCode = keyof typeof PHONE_CUSTOM_MASK;
export type PhoneMaskPattern = (typeof PHONE_CUSTOM_MASK)[PhoneMaskCountryCode];

export const EXCLUDE_COUNTRIES = ['ru'] as const;
export type ExcludedCountryCode = (typeof EXCLUDE_COUNTRIES)[number];
